
import { Question, isQuestionContent } from "@/types/test";

interface QuestionPreviewProps {
  question: Question;
  isSelected: boolean;
  onToggle: () => void;
}

export const QuestionPreview = ({ question, isSelected, onToggle }: QuestionPreviewProps) => {
  if (!isQuestionContent(question.content)) {
    return null;
  }

  const content = question.content;
  const isMultipleChoice = question.question_type === 'multiple_choice' && 
    'options' in content && 
    Array.isArray(content.options) &&
    'correctOption' in content;

  return (
    <div
      className="p-4 border rounded-sm hover:bg-accent cursor-pointer"
      onClick={onToggle}
    >
      <div className="flex items-start gap-2">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={onToggle}
          className="mt-1"
        />
        <div>
          <p className="font-medium">
            {typeof content.question === 'string' ? content.question : 'Invalid question format'}
          </p>
          {isMultipleChoice && (
            <ul className="mt-2 space-y-1">
              {content.options.map((option: string, i: number) => (
                <li
                  key={i}
                  className={`text-sm ${
                    i === (content.correctOption as number)
                      ? 'text-green-600 font-medium'
                      : 'text-gray-600'
                  }`}
                >
                  {option}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};
